<template>
    <section class="col-12 " :class="mt">
        <label><strong>Documents</strong></label>
        <div class="table table-responsive">
            <table v-if="documents.length > 0" class="table table-responsive table-striped table-bordered d-table">
                <thead>
                <tr>
                    <td style="min-width:20%">Type</td>
                    <td style="min-width:50%">File</td>
                    <td style="min-width:20%">Description</td>
                    <td style="max-width: 10px;">Delete</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, itemIndex) in documents_local">
                    <td>
                        {{ item.type }}
                    </td>
                    <td>
                        <a target="_blank" :href="'/'+item.path">{{ item.file_name ? item.file_name : 'Open File' }}</a>
                    </td>
                    <td>
                        <slot v-if="item.id">
                            <input class="form-control" v-if="documents_local[itemIndex].editing === true"
                                   @blur="saveItem(item, itemIndex)" type="text" v-model="item.description">
                            <span title="Double click to change" v-else
                                  @dblclick="() => documents_local[itemIndex].editing = true">{{
                                    item.description
                                }} <span @click="() => documents_local[itemIndex].editing = true"
                                         class="fa fa-edit text-info"></span></span>
                        </slot>
                        <span v-else>{{ item.description }}</span>
                    </td>
                    <td>
                        <a v-if="item.id" @click="deleteLine(item.id, itemIndex)" title="Delete"
                           class="btn btn-danger text-white"><span
                            class="fa fa-trash"></span></a>
                    </td>
                </tr>
                </tbody>
                <tfoot>
                </tfoot>
            </table>
            <table class="table table-responsive table-striped table-bordered d-table">
                <thead>
                <tr>
                    <td style="width:20% !important;">Type</td>
                    <td style="width:50% !important;">File</td>
                    <td style="width:20% !important;">Description</td>
                    <td style="width: 10% !important;">Delete</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, itemIndex) in items">
                    <td>
                        <select :name="name+'['+itemIndex+'][type]'"
                                class="form-control" @change="setFile">
                            <option v-for="type in types" :value="type.value">{{ type.name }}</option>
                        </select>

                    </td>
                    <td>
                        <input :data-index="itemIndex" :name="name+'['+itemIndex+'][path]'" type="file"
                               @change="onFileChange"
                               class="form-control"/>
                    </td>

                    <td>
                        <input :name="'documents['+itemIndex+'][description]'" type="text"
                               @change="setFile" class="form-control"/>
                    </td>
                    <td><a @click="deleteLine(item.id, itemIndex)" title="Delete"
                           class="btn btn-danger text-white"><span
                        class="fa fa-trash"></span></a></td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                    <th colspan="9">
                        <button @click="addLine()" type="button"
                                class="btn btn-success"
                                data-toggle="tooltip"
                                data-original-title="Add more lines">
                            <i class="glyphicon glyphicon-plus-sign"></i>
                            Add
                        </button>

                    </th>

                </tr>
                </tfoot>
            </table>
        </div>
    </section>
</template>

<script>
import _ from "lodash";
import GDocument from "../../models/GDocument";

export default {
    name: "GlobalDocumentComponent",
    props: {
        documents: {
            type: Array,
            default: []
        },
        types: {
            type: Array,
            default: []
        },
        name: {
            type: String,
            default: 'documents'
        },
        isSubmit: {
            type: Boolean,
            default: false
        },
        index: {
            type: Number,
            default: 0
        },
        autoUpload: {
            type: Boolean,
            default: false
        },
        mt: {
            type: String,
            default: "mt-5"
        },
    },
    data: function () {
        return {
            items: [],
            documents_local: [],
        }
    },
    watch: {
        documents(val) {
            /*  if (val != null && val.hasOwnProperty('length')  && val.length > 0) {
                  this.documents_local = this.documents
              }*/
        }
    },
    mounted() {
        if (this.documents != null && this.documents.hasOwnProperty('length') && this.documents.length > 0) {
            this.documents_local = this.documents.map((e) => {
                e['editing'] = false;
                return e;
            })
        }
    },
    methods: {
        addLine() {
            let item = new GDocument()
            this.items.push(item);
        },
        deleteLine(id, itemIndex) {

            if (id) {
                if (confirm('Are you sure?')) {
                    this.$loading(true);
                    let app = this;
                    axios.delete('/documents/' + id)
                        .then((response) => {
                            this.$loading(false);
                            app.documents_local.splice(itemIndex, 1);
                        })
                        .catch(error => {
                            this.$loading(false);
                            let message = '';
                            if (_.has(error, 'response.data.friendly_message')) {

                                message = error.response.status + ' - ' + error.response.data.friendly_message;

                            } else if (_.has(error, 'response.status')) {

                                message = 'Request failed with status code ' + error.response.status;

                            } else {
                                message = 'Application failed with error: ' + error.message;
                                console.log(error);
                            }

                            showMessage('w', message);


                        })
                }
            } else {
                this.items.splice(itemIndex, 1);
            }

        },
        onFileChange(e) {
            if (!this.autoUpload) return;
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            let index = e.target.getAttribute('data-index')
            let app = this;
            this.fileReader(files[0], function (result) {
                app.upload(result, files[0].name, index);
            });
            //this.items[index].path = files[0];
        },
        fileReader(file, callback) {
            let app = this;
            if (window.File && window.FileReader && window.FileList && window.Blob) {
                if (file) {
                    var reader = new FileReader();
                    reader.onloadend = () => {
                        callback(reader.result);
                    };

                    reader.readAsDataURL(file);

                    reader.onabort = function () {
                        showMessage('e', "The upload was aborted");
                    }

                    reader.onerror = function () {
                        showMessage('e', "There was an error reading the file");
                    }
                }

            } else {
                showMessage('e', 'The File APIs are not fully supported in this browser.');
            }
        },
        upload(dataUrl, filename, index) {
            let app = this
            axios.post('/upload-document', {
                dataEncoded: dataUrl,
                filename: filename,
                folder: 'documents'
            })
                .then((response) => {
                    app.items[index].path = response.data.data.filename
                })
                .catch(error => {

                    if (error.response.status === 500) {
                        showMessage('e', 'Could not complete request');
                    }

                    if (error.response.status === 401) {
                        showMessage('w', error.response.data.server_error);
                    }

                    if (error.response.status === 405) {
                        showMessage('w', 'Upload URL is not valid');
                    }

                    if (error.response.status === 400) {
                        this.errors = error.response.data.errors || {};
                        showMessage('w', 'Fill in all mandatory fields');
                    }
                })
                .finally(() => null)
        },
        saveItem(item, index) {
            let app = this
            axios.put(`/documents/${item.id}`, item)
                .then((response) => {
                    //showMessage('s', 'Successfully updated!')
                })
                .catch(error => {

                    if (error.response.status === 500) {
                        showMessage('e', 'Could not complete request');
                    }

                    if (error.response.status === 401) {
                        showMessage('w', error.response.data.server_error);
                    }

                    if (error.response.status === 405) {
                        showMessage('w', 'Upload URL is not valid');
                    }

                    if (error.response.status === 400) {
                        this.errors = error.response.data.errors || {};
                        showMessage('w', 'Fill in all mandatory fields');
                    }
                })
                .finally(() => {
                    app.documents_local[index].editing = false;
                })
        },
        setFile() {
            this.$emit('getFiles', this.items, this.index)
        }
    }
}
</script>

<style scoped>
.form-group input[type=file] {
    width: 100% !important;
    position: relative;
    opacity: 100 !important;
    padding: 7px 15px !important;
}
</style>
